export const capitalise = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const convertObjectToString = (obj: unknown) =>
  JSON.stringify(obj, null, 1)
    .replace(/"([^(")]+)":/g, '$1:')
    .replace(/"/g, "'");

export const joinClassNames = (...classes: Array<string | boolean | undefined>) =>
  classes.filter((element) => typeof element === 'string').join(' ');

// Value must be a whole number in string format
export const addThousandsSeparators = (value: string) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
